import { render } from "./AgbComponent.vue?vue&type=template&id=6e169869&ts=true"
import script from "./AgbComponent.vue?vue&type=script&lang=ts"
export * from "./AgbComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__